import React, { useState, useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: '¿Esto es un libro físico?',
  answer: 'No. Es un ebook en formato PDF que recibes inmediatamente después del pago en tu email. Sin envíos, sin esperas.'
}, {
  question: '¿Cuándo lo recibo?',
  answer: 'En menos de 60 segundos. Una vez que completas el pago, recibes un email automático con el enlace de descarga. Lo puedes leer en el mismo momento.'
}, {
  question: '¿Puedo leerlo en mi teléfono o tablet?',
  answer: 'Sí. El PDF está optimizado para todos los dispositivos — iPhone, Android, iPad, Kindle y cualquier computadora.'
}, {
  question: '¿Este libro es periodismo o es opinión?',
  answer: 'Es análisis documentado. Cada capítulo está basado en hechos verificables, testimonios reales y registros históricos. No es propaganda — es memoria histórica contada sin filtros editoriales.'
}, {
  question: '¿Cuál es la política de reembolso?',
  answer: 'Garantía total de 14 días. Si el libro no cumple tus expectativas por cualquier razón, escríbenos y te devolvemos el dinero completo. Sin preguntas, sin complicaciones.'
}];
function AccordionItem({
  item,
  isOpen,
  onToggle
}: {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div style={{
    borderBottom: '1px solid rgba(255,255,255,0.06)'
  }} data-id="element-91">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left gap-4" data-id="element-92">
        <span className="text-white font-semibold text-[15px] font-['Inter',sans-serif]" data-id="element-93">
          {item.question}
        </span>
        <span className="text-[#cc0000] text-xl font-bold flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300" style={{
        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
      }} data-id="element-94">
          +
        </span>
      </button>
      <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
      maxHeight: isOpen ? '300px' : '0px',
      opacity: isOpen ? 1 : 0
    }} data-id="element-95">
        <p className="text-[#888888] text-sm leading-relaxed pb-5 font-['Inter',sans-serif]" data-id="element-96">
          {item.answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] px-6" style={{
    padding: '80px 24px'
  }} data-id="element-97">
      <div className="max-w-[680px] mx-auto" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-12" data-id="element-99">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-100">
            Preguntas frecuentes
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-101">
            Resolvemos tus dudas
          </h2>
          <div className="gold-divider" data-id="element-102" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-103">
          {faqs.map((faq, index) => <AccordionItem key={index} item={faq} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-104" />)}
        </motion.div>
      </div>
    </section>;
}